import { Model } from '@vuex-orm/core'
import { Unit, Subject } from 'src/store/models/timetable/index.js'
import { UnitsTo, UnitsFrom } from 'src/store/models/pivot/index.js'

export class Substitution extends Model {
  static entity = 'substitutions'

  static fields () {
    return {
      id: this.uid(),
      school_id: this.attr(null),
      name: this.string('').nullable(),
      kind: this.string('').nullable(),
      description: this.string('').nullable(),
      comment: this.string('').nullable(),
      intern_id: this.attr([]),
      created_at: this.attr([]),
      updated_at: this.attr([]),
      subject_id: this.attr(null),
      subject: this.belongsTo(Subject, 'subject_id'),
      units_from_pivot: this.hasMany(UnitsFrom, 'unit_id'),
      units_from: this.belongsToMany(Unit, UnitsFrom, 'substitution_id', 'unit_id'),
      units_to_pivot: this.hasMany(UnitsTo, 'unit_id'),
      units_to: this.belongsToMany(Unit, UnitsTo, 'substitution_id', 'unit_id'),
      is_hidden: this.boolean(false)
    }
  }
}

export default Substitution
